const menuPallete = (tokens) => {
    return {
        background: {
            color: tokens.menuColorBg
        },
        border: {
            color: tokens.menuColorBorder,
            width: tokens.menuBorderWidth,
            radius: tokens.menuRadius
        },
        padding: tokens.menuPadding,
        spaceBetween: tokens.menuSpaceBetween,
        boxShadow: tokens.menuBoxShadow
    };
};
export default menuPallete;
//# sourceMappingURL=menu.js.map